import { TUserRole } from '../../types/currentUser';
import { TApplicationState } from '../../types/redux';

const PROFESSIONAL_ROLES: TUserRole[] = ['specialist', 'builder', 'suburbanBuilder'];

export function getIsProfessional(state: TApplicationState) {
  return PROFESSIONAL_ROLES.includes(state.userRole);
}
